import * as Sentry from '@sentry/node'
import * as conf from '../env.config'

const ENDPOINT = typeof window !== 'undefined' ? conf.apiBase : conf.apiRoot + conf.apiBase
const CLIENT_ENDPOINT = conf.apiBase

export function destinationSearchPath(term, limit = 10) {
  return `${ENDPOINT}/search/autocomplete?term=${term}&limit=${limit}`
}

export function configPath(keys) {
  const searchParams = new URLSearchParams({ keys })
  return `${ENDPOINT}/get-config?${searchParams.toString()}`
}

export function airlineDealsPath(airlineSlug) {
  return `${ENDPOINT}/deals/airlines/${airlineSlug}`
}

// color: common_collor, common_white, common_grey
// format: svg, png. git
export function airlineLogoPath(code, color = 'common_white', format = 'svg') {
  return `${ENDPOINT}/airline-logo/${code}/${color}?preferableFormat=${format}`
}
export function clientAirlineLogoPath(code, color = 'common_white', format = 'svg') {
  return `${CLIENT_ENDPOINT}/airline-logo/${code}/${color}?preferableFormat=${format}`
}

export function locationDealsPath(
  locationType,
  location,
  cabinClass,
  sourceId = cabinClass ? null : '2'
) {
  const params = new URLSearchParams()
  if (sourceId) {
    params.append('sourceId', sourceId)
  }
  if (cabinClass) {
    params.append('cabinClass', cabinClass)
  }
  return `${ENDPOINT}/deals/${locationType}/${location}?${params.toString()}`
}

const defaultOptions = {
  headers: { 'Content-Type': 'application/json' },
}

function doFetch(endpoint, method, options) {
  const opts = {
    ...defaultOptions,
    method,
    ...options,
  }

  return fetch(endpoint, opts)
    .then((res) => {
      if (res.ok) {
        return res.json()
      } else {
        let error = new Error(`Request to ${endpoint} failed: [${res.status}] - ${res.statusText}`)
        error.code = res.status
        throw error
      }
    })
    .catch((err) => {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error(err)
      }
      Sentry.captureException(err)
      return {
        error: {
          code: err.code,
          message: err.message,
        },
      }
    })
}

function get(endpoint, options = {}) {
  return doFetch(endpoint, 'GET', options)
}

function post(endpoint, body, options = {}) {
  return doFetch(endpoint, 'POST', { ...options, body: JSON.stringify(body) })
}

export const API = {
  get,
  post,
}
